import { useState, useEffect, useCallback } from 'react';

export const useOnboardingState = (contentId, get, post) => {
  const [onboardingState, setOnboardingState] = useState({
    complete: false,
    dismissedTimes: 0,
    checklistComplete: true,
    neverShowAgain: false,
    showCompleteModal: false,
    showOnboardSkipModal: false
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadState = async () => {
      try {
        const savedState = await get(contentId);
        if (savedState) {
          setOnboardingState(prev => ({
            ...prev,
            ...savedState,
            showOnboardSkipModal: false,
            showCompleteModal: false
          }));
        }
      } catch (e) {
        console.error('Error loading onboarding state:', e);
      } finally {
        setLoading(false);
      }
    };

    if (contentId) {
      loadState();
    }
  }, [contentId, get]);

  const saveState = useCallback(
    updates => {
      const newState = { ...onboardingState, ...updates };
      post(contentId, newState);
      setOnboardingState(newState);
    },
    [onboardingState, contentId, post]
  );

  return { onboardingState, saveState, loading };
};
